import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate, useLocation  } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import useAppLayout from './hooks/useAppLayout';
import API_URL from './api/config';
import { useQuery, useQueryClient } from '@tanstack/react-query';

import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactModal from 'react-modal';

function TreeSubscriptionNow() {
  const location = useLocation();
  const planId_name = location.state?.planId_name;
  const verifyCode = location.state?.verifyCode;

  
  const [iframeUrl, setIframeUrl] = useState(null);

  useEffect(() => {
    const startPayment = async () => {
      try {
        const res = await fetch("https://oret.africa/tree/backend/api/pesapal/iframe", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ planId_name, verifyCode }), // send values
        });
        const data = await res.json();
        if (data.iframe_url) {
          setIframeUrl(data.iframe_url);
        } else {
          console.error("No iframe_url returned", data);
        }
      } catch (err) {
        console.error("Payment iframe fetch failed:", err);
      }
    };

    if (planId_name && verifyCode) {
      startPayment();
    }
  }, [planId_name, verifyCode]);

  return (
    <div className="">
      <ToastContainer />
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card">
               
              <div className="card-body" style={{ overflowY: "auto", maxHeight: "90vh" }}>
  {iframeUrl ? (
    <iframe
      src={iframeUrl}
      width="100%"
      height="700px"
      scrolling="yes"   // enable iframe scroll
      frameBorder="0"
      style={{ border: "none" }}
    />
  ) : (
    <p>Loading payment page...</p>
  )}
</div>
              </div>
            </div>
          </div>
          <div className="row end-page-space"></div>
        </div>
      </div>
    </div>
  );
}

export default TreeSubscriptionNow;